import { render, staticRenderFns } from "./profile-write-up-sign.vue?vue&type=template&id=20425ff8"
import script from "./profile-write-up-sign.vue?vue&type=script&lang=js"
export * from "./profile-write-up-sign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports